import errorRes from '../utils/errorRes';
import API from './baseApi';

export const postLogin = async (data) => {
	try {
		const response = await API.post('/admin/login', data);

		return response.data;
	} catch (error) {
		return Promise.reject(errorRes(error));
	}
};

export const postLogout = async (refreshToken) => {
	try {
		const response = await API.post('/admin/logout', { refreshToken });

		return response.data;
	} catch (error) {
		return Promise.reject(errorRes(error));
	}
};

export const postSendEmailVerification = async ({ clientId, email }) => {
	try {
		const response = await API.post(`/admin/send-verification-email/${clientId}`, { email });

		return response.data;
	} catch (error) {
		return Promise.reject(errorRes(error));
	}
};

export const postChangePasswordAdmin = async ({ token, password }) => {
	try {
		const response = await API.post(`/admin/reset-password?token=${token}`, { password });

		return response.data;
	} catch (error) {
		return Promise.reject(errorRes(error));
	}
};

export const getVerifyResetPasswordTokenAdmin = async (token) => {
	try {
		const response = await API.get(`/admin/reset-password?token=${token}`);

		return response.data;
	} catch (error) {
		return Promise.reject(errorRes(error));
	}
};

export const postForgotPassword = async (email) => {
	try {
		const response = await API.post(`admin/forgot-password`, email);

		return response.data;
	} catch (error) {
		return Promise.reject(errorRes(error));
	}
};

/**
 * User Auth Functions
 */

export const postVerifyEmail = async (token) => {
	try {
		const response = await API.post(`/verify-email?token=${token}`);

		return response.data;
	} catch (error) {
		return Promise.reject(errorRes(error));
	}
};

export const postChangePassword = async ({ token, password }) => {
	try {
		const response = await API.post(`/reset-password?token=${token}`, { password });

		return response.data;
	} catch (error) {
		return Promise.reject(errorRes(error));
	}
};

export const getVerifyResetPasswordToken = async (token) => {
	try {
		const response = await API.get(`/reset-password?token=${token}`);

		return response.data;
	} catch (error) {
		return Promise.reject(errorRes(error));
	}
};

export const getVerifyEmailVerificaitonToken = async (token) => {
	try {
		const response = await API.get(`/verify-email?token=${token}`);

		return response.data;
	} catch (error) {
		return Promise.reject(errorRes(error));
	}
};
